import { isAxiosError } from 'axios';
import axios from 'utils/api';

export async function fetchLastSystemsQuerySql(): Promise<string> {
  try {
    const response = await axios.get<{ sql: string }>('valid-systems/last-sql');
    return response.data.sql;
  } catch (error) {
    if (isAxiosError(error) && error.response?.status === 404) {
      throw new Error('No systems query has run yet');
    }
    throw new Error('Failed to fetch the systems query SQL');
  }
}
